"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MaterialSpinner = void 0;
var _react = _interopRequireWildcard(require("react"));
var _framerMotion = require("framer-motion");
var _usePalette = require("../hooks/usePalette");
var _useMotionProps = require("../motion/useMotionProps");
var styles = _interopRequireWildcard(require("./styles"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const MaterialSpinner = /*#__PURE__*/(0, _react.memo)(({
  size,
  color,
  testID
}) => {
  const palette = (0, _usePalette.usePalette)();
  const svgMotionProps = (0, _useMotionProps.useMotionProps)({
    animate: {
      rotate: [0, 360]
    },
    transition: {
      easing: 'linear',
      duration: 'slow4',
      repeat: Infinity
    }
  });
  const circleMotionProps = (0, _useMotionProps.useMotionProps)({
    initial: {
      strokeDashoffset: 0
    },
    animate: {
      rotate: [0, 135, 360],
      strokeDashoffset: [180, 45, 180]
    },
    transition: {
      easing: 'global',
      duration: 'slow4',
      repeat: Infinity,
      times: [0, 0.5, 1]
    }
  });
  return /*#__PURE__*/_react.default.createElement(_framerMotion.m.svg, _extends({
    "data-testid": testID,
    height: `${size}px`,
    stroke: palette[color],
    viewBox: "0 0 66 66",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgMotionProps), /*#__PURE__*/_react.default.createElement(_framerMotion.m.circle, _extends({
    cx: "33",
    cy: "33",
    fill: "none",
    r: "30",
    strokeLinecap: "round",
    strokeWidth: "6"
  }, circleMotionProps, {
    className: styles.materialSpinner.circle
  })));
});
exports.MaterialSpinner = MaterialSpinner;
MaterialSpinner.displayName = 'MaterialSpinner';